export interface Icon {
  iconWebName: string
  iconMobileName: string
  checked: boolean
}

export const MaterialIconsToLink = (): Icon[] => {
  return [
    { iconWebName: 'insert_link', iconMobileName: '0xe345', checked: false },
    { iconWebName: 'mail_outline', iconMobileName: '0xe3c4', checked: false },
    { iconWebName: 'share', iconMobileName: '0xe593', checked: false },
    { iconWebName: 'attach_money', iconMobileName: '0xe0b2', checked: false },
    { iconWebName: 'call', iconMobileName: '0xe126', checked: false },
    { iconWebName: 'group', iconMobileName: '0xe2eb', checked: false },
    { iconWebName: 'download', iconMobileName: '0xe201', checked: false },
    { iconWebName: 'schedule', iconMobileName: '0xe556', checked: false },
    { iconWebName: 'description', iconMobileName: '0xe1bf', checked: false },
    { iconWebName: 'bar_chart', iconMobileName: '0xe0cc', checked: false },
    { iconWebName: 'event', iconMobileName: '0xe23e', checked: false },
    { iconWebName: 'qr_code_scanner', iconMobileName: '0xe4f7', checked: false, },
    { iconWebName: 'language', iconMobileName: '0xe366', checked: false },
    { iconWebName: 'whatsapp', iconMobileName: '0xf05a6', checked: false },
    { iconWebName: 'instagram', iconMobileName: 'instagram', checked: false },
    { iconWebName: 'youtube', iconMobileName: 'youtube', checked: false },
    { iconWebName: 'facebook', iconMobileName: '0xe255', checked: false },
    { iconWebName: 'twitter', iconMobileName: 'twitter', checked: false },
  ];
};
